import * as Yup from "yup";

export default Yup.object().shape({
    emailAddress: Yup.string()
    .email('Please enter a valid email address')
    .required("Email address is required"),
});